import React, { forwardRef } from 'react';

import { twMerge } from 'tailwind-merge';

import { Input } from '@components/common';
import { Props as InputProps } from '@components/common/Input';
import { LinkSVG } from '@components/svgs';

export const Website = forwardRef<HTMLInputElement, InputProps>(({ className, ...rest }, ref) => {
  return (
    <Input
      ref={ref}
      placeholder='Website link'
      className={twMerge('w-full bg-white', className)}
      icon={LinkSVG}
      {...rest}
    />
  );
});
